import { forwardRef } from 'react';

/**
 * O aviso de que a permissão não pôde ser carregada.
 *
 * **Mora em `components/`, e não junto do provider que o usa, por um motivo de build:** o
 * `content` do Tailwind (`vibTheme/tailwind-theme.js`) varre `vibTheme`, `pages` e `components` —
 * e NÃO varre `contexts`. Classe escrita lá só existe no CSS final por acidente, quando algum
 * arquivo varrido usa a mesma; `bg-warningBg` não seria emitida, e o aviso sairia sem fundo, com
 * texto meio transparente sobre o conteúdo da página.
 *
 * `z-mask` (105), e não `z-appbar` (95): a barra lateral é `z-sidebar` (100) e cobria os 22rem da
 * esquerda deste aviso — no desktop ela abre por padrão, então era o começo da frase que sumia.
 * Abaixo de `popover`, para não passar na frente de diálogo.
 *
 * Preso EMBAIXO porque o provider embrulha as duas famílias de layout e não sabe qual está em uso,
 * então não tem como entrar no esquema de deslocamento do topo. A altura é publicada numa variável
 * de CSS para quem também é fixo embaixo — hoje o `BackToTop` — sair de cima dele.
 */
export const PermissionAlert = forwardRef<HTMLDivElement>((_props, ref) => (
  <div
    ref={ref}
    role="alert"
    className="fixed bottom-0 left-0 right-0 z-mask bg-warningBg p-sm text-center text-warning"
  >
    Não foi possível carregar suas permissões, então nada aparece liberado.
    Recarregue a página; se continuar, fale com o suporte.
  </div>
));

PermissionAlert.displayName = 'PermissionAlert';
